import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler,
    Keyboard,
    ActivityIndicator
} from "react-native";
import HMActionBar from "../../../../../customviews/HMActionBar";
import {serviceActionListNotSendMyApply} from "../../../splash/action/ActionSplashGetAllData";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import i18n from '../../../../../I18n/i18n.js';
import {moderateScale} from "../../../../../tools/Scaling";
//import {Card, CardItem, CheckBox, Content, Icon, Input, Item} from "native-base";

import HMTextInput from "../../../../../customviews/HMTextInput";
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";
import * as NavigationService from "../../../../../redux/NavigationService";
// import Modal from "react-native-modal";

import DialogConnectionCustomize from "../../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import store from "../../../../../redux/store/index";
import {typeExport} from "../../../../../redux/store/type";
import moment from "moment-jalaali";

moment.locale("fa");
moment.loadPersian();
let container = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;
let content = null;
import axios from "axios";
//import Sound from "react-native-sound";
import HMItemCategory from "../../../../../customviews/HMItemCategory";
import HMFiles from "../../../../../customviews/file/HMFiles";
import Steps from "../../../../../customviews/steps/Steps";
import HMAlert from "../../../../../customviews/HMAlert";
import HMFilesTest from "../../../../../customviews/file/HMFilesTest";
import HMListCheckBox from "../../../../../customviews/HMListCheckBox";


const firstIndicatorConfigs = {
    stepIndicatorSize: 30,
    currentStepIndicatorSize: 40,
    separatorStrokeWidth: 3,
    currentStepStrokeWidth: 4,
    separatorFinishedColor: '#4aae4f',
    separatorUnFinishedColor: '#a4d4a5',
    stepIndicatorFinishedColor: '#4aae4f',
    stepIndicatorUnFinishedColor: '#a4d4a5',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 15,
    currentStepIndicatorLabelFontSize: 15,
    stepIndicatorLabelCurrentColor: '#000000',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: 'rgba(255,255,255,0.5)',
    labelColor: '#666666',
    labelSize: 12,
    currentStepLabelColor: '#4aae4f',
};

//var sound = null
var CountSteps = null;
export default class SubmitSwitchingOperationScreen extends Component {

    constructor(props) {
        super(props);
        container = this;
        let {item, res} = this.props.route.params
        // let arr = store.getState().reducerSplashGetAllData.resultsSaina.result.list;
        // arr = arr.find(({type}) => type == item.type);
        // arr = (arr && arr !== null ? arr.subjects : [])
        content = this;
        // let listMenus = store.getState().reducerSplashGetAllData.resultsShahrdar.result.status;
        let listMenus = res.result && (res.result.statuses) ? res.result.statuses : res.result;
        // let listPlace = [];
        let addressMap = "fghjfg"

        this.state = {
            currentPage: 0,
            indexSelectCheckBoxType: 1,

            indexSelectedArray1: -1,
            itemSelectedArray1: null,

            itemSelectedArray1Sub: null,
            indexSelectedArray1Sub: -1,

            indexSelectedArray2: -1,
            itemSelectedArray2: null,


            indexSelectedArray2Sub: -1,
            itemSelectedArray2Sub: null,


            pageDataArray1Sub: [],
            pageDataArray2: [],
            pageDataArray2Sub: [],
            typeButton: "next",
            name: '',
            description: '',
            arrData: [],
            listName: [],


            modalHeight: 0,

            dataSourcearraycategory: [],
            categoryInput: null,
            arraycategory: [],
            Category: {id: 0, value: i18n.t('constant.selectCategory')},

            arrayCategoryType: [],
            categoryTypeInput: null,
            dataSourcearrayCategoryType: [],
            CategoryType: {id: 0, value: i18n.t('constant.selectCategoryType')},

            //   arrayBedrooms: props.DataSplashScreen.results.bedrooms,
            textarrayBedrooms: null,
            dataSourcearrayBedrooms: [],
            bedrooms: {id: 0, value: i18n.t('constant.selectBedrooms')},


            address: addressMap,
            desc: null,


            min: null,
            max: null,
            size: null,

            Modalcategory: false,
            pickedcategory: null,

            visibleCategoryType: false,
            pickedCategoryType: null,

            visibleModal: '',

            ShowImage: false,
            ShowVideo: false,
            ShowAudio: false,

            pathImage: null,
            pathImageVideo: null,
            pathVideo: null,

            index: 0,

            checked: false,
            pathCompress: null,


            currentTime: 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            //  audioPath: AudioUtils.DocumentDirectoryPath + '/' + new Date().getTime() + '.aac',
            audioPath: null,
            //   audioPath: null,
            hasPermission: undefined,
            prepareRecord: true,


            playState: 'record', //playing, paused ,record , stop
            duration: 0,

            arrImage: [],
            alaki: false
        }
        //this.pageDataArray = ['انتخاب وضعیت', 'ضمیمه فایل', 'درج توضیحات'];
        this.pageDataArray = ['', '', ''];
        //  arr.find(({type}) => type == item.type)
        //type=0 => category ,type=1 => not category ,
        this.pageDataArray1 = listMenus
        props.callserviceActionRefresh()

    }

    selectListInFlatlist(index) {
        let d = null;
        switch (index) {
            case 0:
                let {item, res} = this.props.route.params

                let listMenus = this.state.indexSelectCheckBoxType == 2 ? res.result.places : (res.result && (res.result.statuses) ? res.result.statuses : res.result);
                // d = this.pageDataArray1;
                d = listMenus;

                this.nextEmpty(d, this.state.indexSelectedArray1);

                return d

            // case 1:
            //     d = this.pageDataArray1[this.state.indexSelectedArray1].subjects
            //     this.nextEmpty(d, this.state.indexSelectedArray1Sub)
            //     return d

            /*      case 2:
                      d = this.pageDataArray2
                      this.nextEmpty(d, this.state.indexSelectedArray2)
                      return d


                  case 3:

                      // d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                      d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                      this.nextEmpty(d, this.state.indexSelectedArray2Sub)
                      return d*/


        }
    }

    goToIndex(index) {
        setTimeout(function () {


            try {
                content.list.scrollToIndex({animated: true, index: index});

            } catch (e) {

            }

            // alert("df")
        }, 400)
        /*    setTimeout(function(){

                //Put All Your Code Here, Which You Want To Execute After Some Delay Time.
                Alert.alert("Alert Shows After 5 Seconds of Delay.")

            }, 1000);*/
    }

    nextEmpty(data, index) {

        if (data && data.length > 0) {

            this.goToIndex(index, data)
        } else {
            this.setState({
                    currentPage: this.state.typeButton === "next" ? this.state.currentPage + 1 : this.state.currentPage - 1
                },
                () => {

                })
        }

    }


    selectTick(index) {
        switch (container.state.currentPage) {
            case 0:

                return container.state.indexSelectedArray1 == index

            case 1:

                return container.state.indexSelectedArray1Sub == index
            case 2:

                return container.state.indexSelectedArray2 == index

            case 3:


                return container.state.indexSelectedArray2Sub == index

        }
    }


    componentWillReceiveProps(propss) {


    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }


    async componentDidMount() {


///////////////////////audio///////////////////////////////
        //  this.prepareRecording()

        ////////////////////////////
        this.setState({
            dataSourcearraycategory: this.state.arraycategory,
        })
        BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);


    }


    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);

    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    goBack() {
        if (this.state.currentPage >= 1) {
            this.setState({currentPage: this.state.currentPage - 1, typeButton: "back"}
                , () => {

                }
            )
        } else {
            NavigationService.Pop();
        }
    }

    handleScroll(event) {
    }

    _onRef = (property, view) => {
        this[property] = view
    }

    _setDataFiles(name, data) {
        container.setState({[name]: data});
    }

    render() {
        let textButtonNext = this.state.currentPage === 2 ? i18n.t('constant.Registration') : i18n.t('constant.next')
        let {item, res} = this.props.route.params
        let optional = (Platform.OS === 'ios' ? {
            //compressImageMaxWidth: Platform.OS==='ios'?10000:1000,
            //  compressImageMaxHeight: Platform.OS==='ios'?10000:1000,
            enableRotationGesture: true,
            // cropping: true,
            compressImageQuality: .5
        } : {
            compressImageMaxWidth: 1000,
            compressImageMaxHeight: 1000,
            enableRotationGesture: true,
            cropping: true,
            // compressImageQuality:.5
        });

        let listFlatList = this.selectListInFlatlist(this.state.currentPage);

        return (
            <View style={{flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        <HMActionBar menu={false}
                                     props={this.props} statusBarTransparent
                            // text={i18n.t('Privatizations.title')}
                                     text={i18n.t('constant.Switching')}
                                     headerVisibility
                                     more_menu
                                     back
                                     onBackPress={() => this.props.navigation.pop()}

                        />
                        <View

                            style={styles.stepIndicator}>

                            <Steps
                                configs={firstIndicatorConfigs}
                                current={this.state.currentPage}
                                // reversed={true}
                                // labels={this.pageDataArray}

                                count={3}
                            />
                        </View>


                        <View
                            ref={(ref) => {
                                this.contView = ref;
                            }}
                            style={{flex: 1}}
                        >

                            <View style={{
                                flex: 1,
                                //backgroundColor:"#2cee86"
                            }}>


                                {
                                    this.state.currentPage === 0 && (res && res.result && res.result.statuses && res.result.places) ?
                                        <View style={{width: "100%"}}>
                                            <HMListCheckBox
                                                data={{
                                                    list: [
                                                        {id: 1, name: "تغییر وضعیت"},
                                                        {id: 2, name: "ارجاع"},

                                                    ],
                                                    indexSelect: this.state['indexSelectCheckBoxType'],
                                                    name: 'Type',

                                                }}
                                                onPress={
                                                    this.onPressSelectCheckBox
                                                }

                                            />
                                        </View>
                                        :
                                        null
                                }
                                {
                                    this.state.currentPage === 1 ?
                                        //       <HMFiles stateParent={this.state} func={container._setDataFiles} _setStateData={container._setStateData}/>
                                        <HMFilesTest
                                            stateParent={this.state}
                                            _setStateData={container._setStateData}
                                            // _setStateDataParent={container.props._setStateData}
                                            SizeBox={3}
                                            //  styleRoot2={{flexDirection: 'row',}}
                                            //clearState={this.clearState}
                                            styleRoot2={{
                                                flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                width: "100%",

                                                // flexGrow: 1,
                                                //  backgroundColor: "#ee04d0",
                                                alignItems: "flex-start"

                                            }}
                                        />
                                        :
                                        null
                                }

                                {
                                    this.state.currentPage === 2 ?

                                        <View
                                            style={{
                                                position: 'absolute',
                                                flex: 1,
                                                // height:'100%',
                                                // alignContent: 'center',
                                                // alignItems: 'center',
                                                //  justifyContent: 'center',

                                                top: 0,
                                                bottom: 0,
                                                right: 0,
                                                left: 0,
                                                backgroundColor: 'rgba(0,0,0,0.01)',
                                                zIndex: 999
                                            }}>

                                            <View
                                                style={{
                                                    paddingVertical: moderateScale(10),
                                                    marginHorizontal: moderateScale(6)
                                                }}
                                            >
                                                <HMTextInput
                                                    value={this.state.description}
                                                    number
                                                    onChangeText={text => {
                                                        this.setState({description: text})
                                                    }}

                                                    _height={moderateScale(100)}
                                                    //   keyboardType="numeric"
                                                    placeholder={i18n.t('constant.PlaceholderDesc')}
                                                    style={{
                                                        // height:moderateScale(100),
                                                        fontSize: moderateScale(14)
                                                    }} underlineColorAndroid="transparent"
                                                    styleInput={{height: moderateScale(80)}}

                                                    // textCenter={'center'}
                                                />


                                            </View>

                                        </View>
                                        :
                                        null
                                }

                                <FlatList
                                    ref={(ref) => {
                                        this.list = ref;
                                    }}
                                    onScroll={(e) => this.handleScroll(e)}
                                    //    scrollEnabled={false}
                                    //      numColumns={3}
                                    //       data={this.pageDataArray1}
                                    data={listFlatList}
                                    // data={this.selectListInFlatlist(this.state.currentPage)}
                                    keyExtractor={(item, index) => item.svg}
                                    renderItem={({item, index}) =>
                                        <HMItemCategory
                                            selectTick={container.selectTick}
                                            currentPage={this.state.currentPage}
                                            item={item} index={index}
                                            onPress={
                                                () => container.goNext(item, index)
                                            }/>
                                    }
                                />
                            </View>

                            <View
                                style={{
                                    width: '100%',
                                    height: moderateScale(42),
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: moderateScale(8)
                                }}>

                                {


                                    <View
                                        style={{
                                            width: '100%',
                                            height: moderateScale
                                            (42),
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: moderateScale(8)
                                        }}
                                    >
                                        <TouchableOpacity
                                            onPress={() => {
                                                // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                                //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                                this.goBack();
                                            }}
                                            style={{
                                                flex: .48,
                                                height: moderateScale(42),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.colorPrimary,
                                                borderRadius: moderateScale(6)

                                            }}>

                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={i18n.t('constant.Back')} type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginVertical: moderateScale(6),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.white
                                                }}/>
                                        </TouchableOpacity>

                                        <View style={{width: moderateScale(8)}}/>
                                        <TouchableOpacity

                                            onPress={() => {
                                                //   this.refs['viewPager'].setPage(this.state.currentPage + 1);
                                                if (this.state.currentPage < 2) {
                                                    // indexSelectedArray1: -1,
                                                    //     itemSelectedArray1: null,
                                                    //
                                                    //     itemSelectedArray1Sub: null,
                                                    //     indexSelectedArray1Sub: -1,
                                                    //
                                                    //     indexSelectedArray2: -1,
                                                    //     itemSelectedArray2: null,
                                                    //
                                                    //
                                                    //     indexSelectedArray2Sub: -1,
                                                    //     itemSelectedArray2Sub: null,

                                                    if (this.state.currentPage == 0 && this.state.indexSelectedArray1 == -1)
                                                        HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                                                                // {text: 'Ask me later', onPress: () => {}},
                                                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                                {
                                                                    text: i18n.t('constant.ok'), onPress: () => {
                                                                    }
                                                                },
                                                            ],
                                                            {cancelable: true}
                                                        )

                                                    else
                                                        this.setState({
                                                                typeButton: "next",
                                                                currentPage: this.state.currentPage + 1
                                                            }
                                                            , () => {

                                                            }
                                                        )
                                                } else {


                                                    this.setData()
                                                }


                                            }}
                                            style={{
                                                flex: .48,
                                                height: moderateScale(42),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.colorPrimary,
                                                borderRadius: moderateScale(6)
                                            }}>
                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={textButtonNext} type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginVertical: moderateScale(6),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.white
                                                }}/>
                                        </TouchableOpacity>
                                    </View>

                                }

                            </View>

                        </View>

                        {
                            this.props.NoInternetDialog ?
                                <DialogConnectionCustomize
                                    onPress={() => this.checkMobile(this.state.mobile)}
                                />
                                :
                                null
                        }
                        {
                            this.props.isLoading || this.props.isLoadingSet || this.state.isLoadingCompress ?
                                <DialogLoadingCustomize
                                    text={this.state.isLoadingCompress ? "درحال کاهش حجم فایل" : null}
                                />
                                :
                                null
                        }
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
            },
            () => {
            })
    }

    goNext(item, index) {
        let selectItem = "selectItem_" + index
        let selectIndex = "selectIndex_" + index

        //   let nameState= I

        switch (container.state.currentPage) {
            case 0:

                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1: index,
                        itemSelectedArray1: item,

                        itemSelectedArray1Sub: null,
                        indexSelectedArray1Sub: -1,
                        // itemSelectedArray1Sub: item.subjects[0],
                        // indexSelectedArray1Sub: 0,
                        typeButton: "next",
                        currentPage: container.state.currentPage + 1
                        //pageDataArray1Sub:container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {


                        let r = "ref_Image"

                        //  content.list.scrollToIndex(item)
                        // this[r].measureLayout(
                        //  container.list.measureLayout(
                        //      ReactNative.findNodeHandle(container._scroll),
                        //      (x, y) => {
                        //          container._scroll.scrollTo({
                        //              x: 0,
                        //              y: y - moderateScale(40),
                        //              animated: true
                        //          });
                        //      }
                        //  );

                        //   container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;

            case 1:
                container.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1Sub: index,
                        itemSelectedArray1Sub: item,
                        typeButton: "next"
                        //  pageDataArray1Sub:container.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        container.setState({currentPage: container.state.currentPage + 1})
                        //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
//
                    }
                )
                break;
            case 2:
                /*       container.setState(prevState => ({
                               [selectItem]: item,
                               [selectIndex]: index,
                               indexSelectedArray2: index,
                               itemSelectedArray2: item,

                               //   itemSelectedArray2Sub: item.subplaces[0],
                               // indexSelectedArray2Sub: 0,

                               itemSelectedArray2Sub: null,
                               indexSelectedArray2Sub: -1,
                               typeButton: "next"
                               // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                           }),
                           () => {

                               container.setState({currentPage: container.state.currentPage + 1})
                               //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
    //
                           }
                       )*/
                break;

            case 3:
                /*   container.setState(prevState => ({
                           [selectItem]: item,
                           [selectIndex]: index,
                           indexSelectedArray2Sub: index,
                           itemSelectedArray2Sub: item,
                           typeButton: "next"
                           //pageDataArray1Sub: container.pageDataArray1[index]
                           // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                       }),
                       () => {

                           container.setState({currentPage: container.state.currentPage + 1})
                           //      container._scrollIntoView("ref_" + container.state.ListMoveToErrore[0])
    //
                       }
                   )*/
                break;
        }
        /*    }
            else {
                container.setState({currentPage: container.state.currentPage + 2})
            }
    */

        /* NavigationService.navigateParams((item.types && item.types.length > 0) ? "ChildChildSubCategoryScreen" : "PrivatizationsScreen", {
             id: item.id,
             ItemsSelect: {
                 item_Category: props.ItemsSelect.item_Category,
                 item_SubCategory: props.ItemsSelect.item_SubCategory,
                 item_ChildSubCategory: item
             }
         })*/


    }

    onChangecategory(index, data) {

        container.setState({
            Category: {value: data.name, id: data.id},
            CategoryType: {value: i18n.t('constant.selectCategoryType'), id: 0},
            arrayCategoryType: data.subjects,
            dataSourcearrayCategoryType: data.subjects,
            visibleModal: ''
        })
    }

// onChangecategory = (index, item) => {
// }
    onChangeCategoryType(index, data) {
        container.setState({
            CategoryType: {value: data.subjects_tks_subject, id: data.subjectsid},
            visibleModal: ''
            //CategoryType: {value: i18n.t('constant.selectCategoryType'), id: 0},

            // arrayCategoryType: data.CategoryType

        })
    }


    _changeTextAddress(text) {
        this.setState({address: text});
    }


    _changeTextDesc(text) {
        this.setState({desc: text});
    }


    _setDataFiles(name, data) {
        container.setState({[name]: data});
    }


    _setStateData(object) {
        container.setState(object);
    }


    async setData() {
        let {token} = store.getState().reducerSplashGetAllData
        let {item} = this.props.route.params

        var shahrvandFlag = store.getState().reducerSplashGetAllData.TypeLogin != 2;
        if (store.getState().reducerSplashGetAllData.Connection) {
            let paramss = {
                "_operation": shahrvandFlag ? typeExport._Contacts : typeExport._Shahrdar,
                "mode": shahrvandFlag ? "AddCommentUser" : typeExport._SaveComments,
                "lang": i18n.locale,
                "_session": token,
                // "type": item.type,

                "record": item.messageid,
                "tracking_code": item.trackingCode ? item.trackingCode : item.code,
                "status": this.state.indexSelectCheckBoxType == 2 ? null : this.state.itemSelectedArray1.name,
                "place": this.state.indexSelectCheckBoxType == 2 ? this.state.itemSelectedArray1.name : null,
                "isRefrence": this.state.indexSelectCheckBoxType == 2 ? 1 : 0,
                // "status":"sjhcd",
                "comment": this.state.description,

                "image": this.state.pathImage,
                "video": this.state.pathVideo,
                "audio": this.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,
                "audioBlob": this.state.ShowAudio && Platform.OS === "web" ? (this.state.audioBlob) : null,
                "durationVoice": this.state.ShowAudio ? (this.state.durationVoice) : null,

                "arrImage": this.state.arrImage,
                "shahrvandFlag": shahrvandFlag,

                /*         "category": this.state.Category.value,
                         "subject": this.state.CategoryType.value,
                         "subjectid": this.state.CategoryType.id,*/

                // "category": this.state.itemSelectedArray1.name,
                // "subject": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjects_tks_subject ? this.state.itemSelectedArray1Sub.subjects_tks_subject : this.state.itemSelectedArray1.name,
                // "subjectid": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjectsid ? this.state.itemSelectedArray1Sub.subjectsid : this.state.itemSelectedArray1.id,
                // "description": this.state.description,
                // "address": this.state.address,
                //  "longitude": this.props.route.params.position.long,
                //  "latitude": this.props.route.params.position.lat,
                "date": moment().format("jYYYY/jM/jD HH:mm:ss"),
                //  "private": this.state.checked ? "1" : "0",

                //"token_fb": this.props.DataSplashScreen.token_fb,
            };
            // if (this.state.Category.id === 0) {
            //     Alert.alert(i18n.t('constant.message'), i18n.t('constant.selectCategory'), [
            //             // {text: 'Ask me later', onPress: () => {}},
            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
            //             {text: i18n.t('constant.ok'), onPress: () => {}},
            //         ],
            //         {cancelable: true}
            //     )
            // } else {
            //     if (this.state.CategoryType.id === 0) {
            //         Alert.alert(i18n.t('constant.message'), i18n.t('constant.selectCategoryType'), [
            //                 // {text: 'Ask me later', onPress: () => {}},
            //                 // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
            //                 {text: i18n.t('constant.ok'), onPress: () => {}},
            //             ],
            //             {cancelable: true}
            //         )
            //     } else {
            //         //   let {mobile, password} = this.state;


            this.props.callService(
                shahrvandFlag ? typeExport._baseUrlSainaShahrvand : typeExport._baseUrlSainaShahrdar,
                paramss,
                typeExport.TypeSetSubmitSwitchingOperationScreen,
                "POST",
                token
            );
            //this.GoScreen()
            //     }
            // }
        } else {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.retry'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                            // NavigationService.BackTo(2)
                            //  NavigationService.navigatereset("ApplyScreen", {item: item})
                        }
                        //  NavigationService.navigatereset("ApplyScreen",{item: item})

                        , style: 'cancel'
                    },

                ],
                {cancelable: true}
            )
            /*  let list = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyOffline + item.type);
              let data = {
                  "_operation": typeExport._Contacts,
                  "mode": "SaveTickets",
                  "lang": i18n.locale,
                  "token": token,
                  "type": item.type,

                  "image": this.state.pathImage,
                  "video": this.state.pathVideo,
                  "audio": this.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,

                  // "category": this.state.Category.value,
                  // "subject": this.state.CategoryType.value,
                  // "subjectid": this.state.CategoryType.id,

                  "category": this.state.itemSelectedArray1.name,
                  "subject": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjects_tks_subject ? this.state.itemSelectedArray1Sub.subjects_tks_subject : this.state.itemSelectedArray1.name,
                  "subjectid": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjectsid ? this.state.itemSelectedArray1Sub.subjectsid : this.state.itemSelectedArray1.id,


                  "description": this.state.description,
                  //  "address": this.state.address,
                  // "longitude": this.props.route.params.position.long,
                  // "latitude": this.props.route.params.position.lat,
                  "index": (list != null && list.length > 0) ? list.length + 1 : 1,
                  "date": moment().format("jYYYY/jM/jD HH:mm:ss"),
                  //   "private": this.state.checked ? "1" : "0",
                  //"token_fb": this.props.DataSplashScreen.token_fb,
                  "arrImage": this.state.arrImage

              };


              if (list != null && list.length > 0) {
                  list.push(data)

              } else {
                  list = [];
                  list.push(data)
              }


              await
                  AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListOperatorApplyOffline + item.type, list)
              // this.props.callServiceListNotSendMyApply(list)
              store.dispatch(serviceActionListNotSendMyApply(list));
              Alert.alert(
                  i18n.t('constant.message'),
                  i18n.t('constant.RequestSuccessfullyRegistered'),
                  [
                      // {text: 'Ask me later', onPress: () => {}},
                      {
                          text: i18n.t('constant.ok'), onPress: () => {
                              NavigationService.BackTo(2)
                              //  NavigationService.navigatereset("ApplyScreen", {item: item})
                          }
                          //  NavigationService.navigatereset("ApplyScreen",{item: item})

                          , style: 'cancel'
                      },

                  ],
                  {cancelable: true}
              )*/


        }


    }

}

const styles = StyleSheet.create({
    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    stepIndicator: {
        marginVertical: moderateScale(6)
    },
    page: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    progressText: {

        paddingTop: moderateScale(50),
        fontSize: moderateScale(50),
        color: "#fff",
    },
    progressTextPlay: {
        paddingTop: moderateScale(25),
        fontSize: moderateScale(25),
        color: "#fff"
    },
    button: {
        padding: moderateScale(20)
    },
    disabledButtonText: {
        color: '#eee'
    },
    buttonText: {
        fontSize: moderateScale(20),
        color: "#fff"
    },
    activeButtonText: {
        fontSize: moderateScale(20),
        color: "#B81F00"
    }
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});
